import { AttachmentSection } from "@domain/lms/article/article";
import { SectionController } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionController";

export class AttachmentSectionController extends SectionController<AttachmentSection> {
	setTitle(title: string): void {
		this.sectionUpdater((current) => ({ ...current, title }));
	}
}
